import React from 'react'
import { connect } from 'react-redux'
import { setLoading } from '../../../action/loading-actions'
import './index.scss'

class SplashScreen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      login: false,
      hideButtons: true
    }
    this.props.auth != null
  }

  componentDidMount() {
    if (this.props.auth) {
      this.setState({ login: false })
    }
  }

  handlleLogin = () => {
    this.setState({ login: true, hideButtons: false })
    this.props.setLoading(true)
  }

  render() {
    return (
      <div className="splash-screen">
        <div className="splash-screen-spinner-container">
          {this.props.loading ?
            <div className="loader-spinner"></div>
            // <img className="splash-screen-spinner" src={SplashScreenLoader} />
            : null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.loading,
  auth: state.auth
})
const mapDispatchToProps = dispatch => ({
  setLoading: () => dispatch(setLoading()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen)
